import { NHVirtualForm } from '../../../../../utils/NHVirtualForm.js';
import { message } from 'antd';
let md5 = require('md5');

/**
 * 天津天狮单点跳转
 * @param {*} csxx 配置参数
 * @param {*} xsxx 学生信息
 * @param {*} jfxm 缴费项目（预留）
 */
export const handle = (csxx, xsxx, jfxm) => {
    let xh =xsxx.DSFZH;
    let key = csxx.key;
    let tm = getNowFormatDate();
    let url = csxx.dddlljdz || csxx.pczflj;

    if (!url) {
        message.info('支付路径不能为空，请联系管理员！');
        return;
    }
    if (!xh) {
        message.info('学号或考生号不能为空，请联系管理员！');
        return;
    }
    if (!key) {
        message.info('参数不能为空，请联系管理员！');
        return;
    }

    let sign = md5(xh + tm + key);
    let map = {
        xh: xh,
        tm: tm,
        sign: sign,
    };

    NHVirtualForm(url, '_blank', map);
};

// 获取当前日期时间，格式 yyyyMMddHHmmss
function getNowFormatDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    let strDate = date.getDate();

    if (month >= 1 && month <= 9) {
        month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate;
    }
    if (hours >= 0 && hours <= 9) {
        hours = '0' + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = '0' + seconds;
    }

    return year + month + strDate + hours + minutes + seconds;
}
